import React from 'react';
import PropTypes from 'prop-types';
import GenericButton from '../common/GenericButton';
import { MME_VALIDATE_MODAL_HEADING, MME_VALIDATE_MODAL_CONTINUE_LABEL,
  MME_VALIDATE_MODAL_CANCEL_LABEL,
  MME_VALIDATE_MODAL_VIEWER_CONTINUE_LABEL } from './MMEConstants';

const MMEValidateStudyModal = props => (
  <div>
    <div className="row margin-0">
      <div className="large-12 columns">
        <h4>{MME_VALIDATE_MODAL_HEADING}</h4>
        <h5>{props.mmeViewer ? MME_VALIDATE_MODAL_VIEWER_CONTINUE_LABEL
        : MME_VALIDATE_MODAL_CONTINUE_LABEL}</h5>
        <h5>{MME_VALIDATE_MODAL_CANCEL_LABEL}</h5>
      </div>
    </div>
    <div className="modal-footer">
      <GenericButton
        name="CONTNUE"
        btnStyle="button btn-cncl float-right"
        onBtnClick={() => props.handleContinueClick()}
      />
      <GenericButton
        name="CANCEL"
        btnStyle="button btn-cncl float-right btn-right-margin"
        onBtnClick={() => props.handleCancelClick()}
      />
    </div>
  </div>
);

MMEValidateStudyModal.propTypes = {
  handleCancelClick: PropTypes.func,
  handleContinueClick: PropTypes.func,
  moduleStudy: PropTypes.shape({}),
  invalidData: PropTypes.shape({
    TargetsGrid: PropTypes.shape({}),
    basesGrid: PropTypes.shape({}),
  }),
  mmeViewer: PropTypes.bool,
};

export default MMEValidateStudyModal;
